module.exports = __webpack_public_path__ + "static/media/LT.20891f9c.png";